import React from 'react';
import PageContent from 'src/Components/PageContent';
import ProcessingModal from '../ProcessingModal';
import ErrorModal from '../ErrorModal';
import SuccessModal from '../SuccessModal';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { buyPrivateSale, prepareBuyPrivateSale } from 'src/redux/actions';
import { AppError } from 'src/redux/types';
import { formatErrorMessage } from 'src/Pages/ProjectConfirmationPage/Components/ConfirmationModal/utils';
import { navigateToProjectDetail } from 'src/utils/navigate';
import { useConfirmOpenWalletConnect } from 'src/Components/WalletConnectConfirmProvider';

const PrivateSaleConfirmationModal = ({
  onClose,
  data,
  onSubmit
}) => {
  const dispatch = useTypedDispatch();
  const {
    confirmOpenWalletConnect
  } = useConfirmOpenWalletConnect();
  const loading = useTypedSelector(state => state.buyPrivateSale.loading);
  const invalidated = useTypedSelector(state => state.buyPrivateSale.invalidated);
  const error = useTypedSelector(state => state.buyPrivateSale.error);
  React.useEffect(() => {
    const buy = async () => {
      const preparedData = await dispatch(prepareBuyPrivateSale(data));
      confirmOpenWalletConnect(async () => {
        await dispatch(buyPrivateSale(preparedData));
      });
    };

    buy();
  }, []);

  const renderError = () => /*#__PURE__*/React.createElement(ErrorModal, {
    buttonTitle: "I got it",
    message: formatErrorMessage(error),
    onSubmit: onClose,
    onClose: onClose
  });

  const renderLoading = () => /*#__PURE__*/React.createElement(ProcessingModal, {
    content: "Confirm the transaction",
    onClose: onClose
  });

  const renderContent = () => /*#__PURE__*/React.createElement(SuccessModal, {
    onClose: () => {
      onClose();
      navigateToProjectDetail(data.projectID);
    },
    onSubmit: () => onSubmit(data.projectID, data.symbol)
  });

  return /*#__PURE__*/React.createElement(PageContent, {
    error: error !== AppError.NO_ERROR,
    loading: loading,
    invalidated: invalidated,
    renderContent: renderContent,
    renderError: renderError,
    renderLoading: renderLoading
  });
};

export default PrivateSaleConfirmationModal;